/**
 * Skip Captcha utility functions
 * Handles skipCaptcha functionality for testing environments
 */ /**
* Check if the current environment is a testing environment
* @returns {boolean} true if running in testing environment
*/ export var isTestingEnvironment = function isTestingEnvironment() { return process.env.GATSBY_AUTOMATION_TEST === "true"; }; /**
* Check if skipCaptcha is enabled
* @returns {boolean} true if skipCaptcha should be enabled
*/
export var isSkipCaptchaEnabled = function isSkipCaptchaEnabled() {
    var localStorageSkipCaptcha = localStorage.getItem("skipCaptcha") === "true"; // Check if in testing environment
    var inTestingEnv = isTestingEnvironment();
    return localStorageSkipCaptcha && inTestingEnv;
}; /**
 * Initialize skipCaptcha from URL parameters and store in localStorage
 */
export var initializeSkipCaptcha = function initializeSkipCaptcha() { var urlParams = new URLSearchParams(window.location.search); var skipCaptcha = urlParams.get("skipCaptcha"); if (skipCaptcha === "true") {
    localStorage.setItem("skipCaptcha", "true");
}
else if (skipCaptcha === "false") {
    localStorage.removeItem("skipCaptcha");
} };
